import { Action } from 'redux';
import { cloneDeep } from 'lodash';
// Import States.
import {
	AppState,
	ProducerSignupState,
	getInitialProducerSignupState,
} from '@app/redux/states';
// Import Actions.
import {
	LoadPossibleBusinessTypeAction,
	LoadPossibleHeardThroughOptionsAction,
	LoadPossibleMasterProducersAction,
} from '@app/redux/actions';
// Import api models.
import {
	PossibleBusinessType,
	PossibleHeardThroughOption,
	PossibleMasterProducer,
} from '@app/models/api';


/**
 * This handles initializing the state.
 * @param state
 */
const initializeState = (state: AppState): AppState => {
	const newState: AppState = { ...state };

	if (!newState.producerSignup) {
		newState.producerSignup = getInitialProducerSignupState();
	} else {
		newState.producerSignup = cloneDeep(newState.producerSignup);
    }
	return newState;
}

/**
 * Query the state.
 * @param state
 */
let queryProducerSignupState = (state: AppState): ProducerSignupState => {
	return state.producerSignup;
}

// Load Possible Heard Through Options Reducer

const LoadPossibleHeardThroughOptionsReducer = (state: AppState, action: Action): AppState => {
	const loadPossibleHeardThroughOptionsAction: LoadPossibleHeardThroughOptionsAction = action as LoadPossibleHeardThroughOptionsAction;
	const possibleHeardThroughOptions: PossibleHeardThroughOption[] = loadPossibleHeardThroughOptionsAction.possibleHeardThroughOptions;

	// Create copy of the of app state.
	const newState: AppState = initializeState(state);

	newState.producerSignup.heardThroughOptions = possibleHeardThroughOptions;
	newState.producerSignup.areHeardThroughOptionsLoaded = true;

	return newState;
}

// Load Possible Business Types Reducer

const LoadPossibleBusinessTypesReducer = (state: AppState, action: Action): AppState => {
	const loadPossibleBusinessTypeAction: LoadPossibleBusinessTypeAction = action as LoadPossibleBusinessTypeAction;
	const possibleBusinessTypes: PossibleBusinessType[] = loadPossibleBusinessTypeAction.possibleBusinessTypes;

	// Create copy of the of app state.
	const newState: AppState = initializeState(state);

	newState.producerSignup.possibleBusinessTypes = possibleBusinessTypes;
	newState.producerSignup.arePossibleBusinessTypesLoaded = true;

	return newState;
}

// Load Possible Master Producers Reducer

const LoadPossibleMasterProducersReducer = (state: AppState, action: Action): AppState => {
	const loadPossibleMasterProducersAction: LoadPossibleMasterProducersAction = action as LoadPossibleMasterProducersAction;
	const possibleMasterProducers: PossibleMasterProducer[] = loadPossibleMasterProducersAction.possibleMasterProducers;

	// Create copy of the of app state.
	const newState: AppState = initializeState(state);

	newState.producerSignup.possibleMasterProducers = possibleMasterProducers;
	newState.producerSignup.arePossibleMasterProducersLoaded = true;

	return newState;
}

// Export reducers.
export {
	LoadPossibleHeardThroughOptionsReducer,
	LoadPossibleBusinessTypesReducer,
	LoadPossibleMasterProducersReducer,
};

// Export initializers.
export {
	initializeState
}

// Export queries.
export {
	queryProducerSignupState,
};